var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex padding"},[_c('div',{staticClass:"text-ibm-plex-sans-14 ufmr-xl ufmt-md ufmb-md"},[_vm._v(_vm._s(_vm.$t(_vm.label))+" ")]),_c('div',{staticClass:"flex switch-ellipse",class:_vm.getEllipseClass(),on:{"click":_vm.toggle}},[_c('div',{staticClass:"flex switch-circle",class:_vm.getCircleClass()})])])
}
var staticRenderFns = []

export { render, staticRenderFns }